import { Box, Flex, Image } from '@chakra-ui/react';
import { Workspace } from '@/lib/types';

const DEFAULT_BANNER = '/banner-default.png';

type WorkspaceLike = {
  name?: string;
  logo?: string;
  banner_logo?: string;
  banner_image?: string;
};

type Props = {
  workspace: Workspace | WorkspaceLike | null;
};

export default function HomeBanner({ workspace }: Props) {
  const bannerSrc = workspace?.banner_image || DEFAULT_BANNER;

  return (
    <Box mx='auto' width={{ md: '90%' }} maxW='6xl' px={{ base: 4, md: 0 }} pt={{ base: 3, md: 4 }}>
      <Box
        position='relative'
        width='100%'
        minH={{ base: '170px', md: '220px' }}
        borderRadius='2xl'
        overflow='hidden'
        backgroundColor='brand.solid'
        backgroundImage={`url(${bannerSrc})`}
        backgroundSize='cover'
        backgroundPosition='center'
        backgroundRepeat='no-repeat'
        shadow='lg'
      >
        {/* base darkening gradient for legibility */}
        <Box
          position='absolute'
          inset={0}
          background='linear-gradient(180deg, rgba(0,0,0,0.10) 0%, rgba(0,0,0,0.45) 100%)'
          pointerEvents='none'
        />
        {/* radial glow behind centered logo for depth */}
        <Box
          position='absolute'
          inset={0}
          background='radial-gradient(ellipse at center, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 55%)'
          pointerEvents='none'
        />
        <Flex
          position='relative'
          direction='column'
          align='center'
          justify='center'
          height='100%'
          py={{ base: 8, md: 10 }}
          gap={3}
        >
          <Box
            position='relative'
            w={{ base: '112px', md: '144px' }}
            h={{ base: '112px', md: '144px' }}
            bg='white'
            borderRadius='xl'
            display='flex'
            alignItems='center'
            justifyContent='center'
            shadow='0 12px 32px rgba(0,0,0,0.25)'
            overflow='hidden'
            _before={{
              content: '""',
              position: 'absolute',
              inset: '-3px',
              borderRadius: 'xl',
              background: 'rgba(255,255,255,0.18)',
              filter: 'blur(8px)',
              zIndex: -1,
            }}
          >
            <Image
              src={workspace?.banner_logo || workspace?.logo || '/logo.png'}
              alt={workspace?.name || 'Workspace'}
              maxH='80%'
              maxW='80%'
              objectFit='contain'
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}
